import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stop",
  "use": "stop-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"stop\">\n    <rect width=\"13\" height=\"13\" rx=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol